import { Component, OnInit, Input, ElementRef,HostListener,HostBinding,Directive } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PATTERNS } from "../../../../globals";
import { UserService } from "../../../../injections/user.service";

@Component({
    selector: 'user-cleaners',
    templateUrl: '../../templates/partials/user-cleaners.html'
})
export class UserCleanersComponent implements OnInit {

    public editFactData: boolean = false;
    @Input() cleaners;
    public eventMouse = null;
    public hoveredIndex = null;
    constructor(private _fb: FormBuilder, private userService: UserService) { }
    
    public hover(index, $event){
        if($event.type == "mouseenter"){
            this.hoveredIndex = index;
            this.eventMouse = $event.type;
        }else{
            this.hoveredIndex = null;
        }
    }

    public unFav(cleaner) {
        this.userService.unFavCleaner(this.cleaners["id"], cleaner["id_professional"]).subscribe(result => {
            if(result["status"] == "OK"){
                cleaner["isFav"] = false;
            }
        });
    }

    public fav(cleaner: object) {
        this.userService.favCleaner(this.cleaners["id"], cleaner["id_professional"]).subscribe(result => {
            if(result["status"] == "OK"){
                cleaner["isFav"] = true;
            }
        });
    }

    public block(cleaner: object) {
        this.userService.blockCleaner(this.cleaners["id"], cleaner["id_professional"]).subscribe(result => {
            if(result["status"] == "OK"){
                cleaner["blocked"] = 1;
            }
        });
    }

    public unBlock(cleaner: object) {
        this.userService.unBlockCleaner(this.cleaners["id"], cleaner["id_professional"]).subscribe(result => {
            if(result["status"] == "OK"){
                cleaner["blocked"] = 0;
            }
        });
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/user-cleaners.component.ts